import formName from 'constants/formName'
import { StateType, TwoFactorFormType, TwoFactorStepType } from 'data/types'
import { getFormValues as reduxGetFormValues } from 'redux-form'
import { createSelector } from 'reselect'

import app from '../../App/selectors'

const getInitialValues: (state: StateType) => TwoFactorFormType = createSelector(
  app.getModalName,
  (modalName) => {
    if (modalName === 'DISABLE_TWO_FACTOR') {
      return { loading: false, step: 'turnoff' }
    }

    return { loading: false, step: 'verifypassword' }
  }
)

// FIXME "as TwoFactorFormType" should  not be needed as type should be infered, find out what's missing
const getFormValues = (state: StateType): TwoFactorFormType =>
  reduxGetFormValues(formName.TWO_FACTOR)(state) as TwoFactorFormType

const getValues: (state: StateType) => TwoFactorFormType = createSelector(
  getFormValues,
  getInitialValues,
  (values: void | TwoFactorFormType, initialValues: TwoFactorFormType) => values || initialValues
)

const getStep: (state: StateType) => TwoFactorStepType = createSelector(
  getValues,
  (form) => form.step
)

const isLoading: (state: StateType) => boolean = createSelector(getValues, (form) => form.loading)

export default {
  getInitialValues,
  getStep,
  getValues,
  isLoading
}
